var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/avatar/avatar.tsx";
import classNames from 'clsx';
import * as React from 'react';
import StillImage from 'soapbox/components/still-image';
const AVATAR_SIZE = 42;

/** Round profile avatar for accounts. */
const Avatar = props => {
  const {
    src,
    size = AVATAR_SIZE,
    className
  } = props;
  const style = React.useMemo(() => ({
    width: size,
    height: size
  }), [size]);
  return /*#__PURE__*/React.createElement(StillImage, {
    className: classNames('rounded-full', className),
    style: style,
    src: src,
    alt: "Avatar",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 5
    }
  });
};

export { Avatar as default, AVATAR_SIZE };